module.exports = __webpack_public_path__ + "static/img/Joe-Harrison.eca2002.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Joe-Harrison.jpg
// module id = cvCS
// module chunks = 0